import {LoaderService} from '../loader/loader.service';
import {Injectable} from '@angular/core';
import {
  HttpInterceptor,
  HttpRequest,
  HttpResponse,
  HttpHandler,
  HttpEvent,
  HttpErrorResponse
} from '@angular/common/http';
import {Observable} from 'rxjs';
import {map, catchError} from 'rxjs/operators';
import {DialogServiceService} from '../shared/dialog-service.service';
import {AuthServiceService} from '../auth-service.service';
import {mergeMap} from 'rxjs/operators';
import {throwError} from "rxjs";


@Injectable()
export class HttpConfigInterceptor implements HttpInterceptor {
  finished = false;

  constructor(private dialogService: DialogServiceService,
              public loaderService: LoaderService,
              private authService: AuthServiceService) {
  }

  intercept(request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const cognitoUser = this.authService.userPool.getCurrentUser();

    if (cognitoUser == undefined) {
      console.log('httpInterceptor: No current user found, logging out of application');
      this.authService.logoutUser();
      return throwError(() => new HttpErrorResponse({error: 'No user', status: 401}));
    }
    let url_parts = request.url.split('/');
    let last_url_part = url_parts[url_parts.length - 1];
    let api = last_url_part.split('?')[0];
    this.finished = false;
    setTimeout(() => {
      if (!this.finished) {
        this.loaderService.show();
      }
    }, 1000);
    return this.authService.getTokenForAPI(api).pipe(
      mergeMap(accessToken => {
        return next.handle(this.addToken(request, accessToken)).pipe(
          map((event: HttpEvent<any>) => {
            if (event instanceof HttpResponse) {
              this.handleResponse(event);
            }
            return event;
          }),
          catchError((error: HttpErrorResponse) => {
            this.finished = true;
            this.loaderService.hide();
            this.handleError(error, request, next);
            return throwError(() => error);
          })
        )
      })
    )
  }

  private handleResponse(event) {
    this.finished = true;
    this.loaderService.hide();
    if (event !== null && event.hasOwnProperty('body') && event.body !== null
      && event.body.hasOwnProperty('status') && event.body.status !== null
      && event.body.status === 0) {
      if (event.body.hasOwnProperty('error') && event.body.error !== null &&
        event.body.error.hasOwnProperty('code') && event.body.error.code !== null) {
        this.showDialog(event.body.error.uiMessage);
        return;
      }
    }
  }


  private handleError(httpErrorResponse: HttpErrorResponse, request: HttpRequest<any>, next: HttpHandler): Observable<HttpEvent<any>> {
    const status = httpErrorResponse.status;
    const url = httpErrorResponse.url ?? '';

    const parts = (httpErrorResponse.error.path ?? '').split('/');
    const resource = parts[parts.length - 1];

    console.log(`httpInterceptor: Error ${status} from request: ${url}`);

    switch (status) {
      case 403: {
        this.showDialog(`Your user account does not have access to the resource: ${resource}.`);
        break;
      }

      case 401:
        this.showDialog('Unable to sign-in with your credentials, please contact technical support.');
        this.authService.logoutUser();
        break;

      case 400:
      case 500:
      case 503:
        this.showDialog(`The server responded with an error ${status}. Please refresh the page and try again or contact technical support.`);
        break;

      default:
        this.showDialog(`An unexpected error occurred (${status}).`);
        break;
    }

    return throwError(() => httpErrorResponse);
  }

  private addToken(request: HttpRequest<any>, token) {
    return request.clone({headers: request.headers.set('PL_AC_TK', token)});
  }

  private showDialog(msg: string) {
    this.dialogService.confirm('Error', msg).then((confirmed) => {
    });
  }
}
